import React, { useEffect, useState, useContext } from "react";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import TooltipConfig from "../../../../Tooltip";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
import { Table } from "react-bootstrap";

export const TableList = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize } = useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [totalTmaToday, setTotalTmaToday] = useState<number>();
  const [totalTmaLast4Weekdays, setTotalTmaLast4Weekdays] = useState<number>();
  const [totalTmaLast28Days, setTotalTmaLast28Days] = useState<number>();
  const [totalTmaTodayTimeFormat, setTotalTmaTodayTimeFormat] = useState<string>("");
  const [totalTmaLast4WeekdaysTimeFormat, setTotalTmaLast4WeekdaysTimeFormat] = useState<string>("");
  const [totalTmaLast28DaysTimeFormat, setTotalTmaLast28DaysTimeFormat] = useState<string>("");
  const [dayOfWeek, setDayOfWeek] = useState<string>("");

  useEffect(() => {
    const today= new Date();
    const day = today.getDay();
    const weekday = today.toLocaleString('pt-br', {  weekday: 'long' }).split('-');
    if(day === 0 || day === 6) {
      setDayOfWeek(`${weekday[0]}s`);
    } else {
      setDayOfWeek(`${weekday[0]}s-${weekday[1]}s`);
    }
    
    setTotalTmaToday(Number(data.total.tma_today));
    setTotalTmaLast4Weekdays(Number(data.total.tma_last_4_weekdays));
    setTotalTmaLast28Days(Number(data.total.tma_last_28_days));

    const hoursTmaToday = Math.floor((data.total.tma_today) / 60);
    const minutesTmaToday = Math.floor((data.total.tma_today) % 60);
    setTotalTmaTodayTimeFormat(`${hoursTmaToday.toString().padStart(2, '0')}:${minutesTmaToday.toString().padStart(2, '0')}`);

    const hoursTmaLast4Weekdays = Math.floor((data.total.tma_last_4_weekdays) / 60);
    const minutesTmaLast4Weekdays = Math.floor((data.total.tma_last_4_weekdays) % 60);
    setTotalTmaLast4WeekdaysTimeFormat(`${hoursTmaLast4Weekdays.toString().padStart(2, '0')}:${minutesTmaLast4Weekdays.toString().padStart(2, '0')}`);

    const hoursTmaLast28Days = Math.floor((data.total.tma_last_28_days) / 60);
    const minutesTmaLast28Days = Math.floor((data.total.tma_last_28_days) % 60);
    setTotalTmaLast28DaysTimeFormat(`${hoursTmaLast28Days.toString().padStart(2, '0')}:${minutesTmaLast28Days.toString().padStart(2, '0')}`);

    const sizes = getSizesComponent({ id: "table-routes-average-stay-on-interval" });
    if (sizes.width < 345) {
      setFontSize({ id: "table-routes-average-stay-on-interval", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setCompleteRequisition(true);
  }, [data]);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Tabela - Tempo Médio de Entregas em Minutos`}
        id="table-routes-average-stay-on-interval"
      />
      <div
        id={"paddedBox"}
      >
        <div id="chart" style={{ height: heightChart }}>
          <Table
            id="tableRoutesFinishedOnInterval"
            style={{ color: '#fff', textAlign: "center"}}
            bordered
          >
            <thead>
              <tr>
              </tr>
            </thead>
            <tbody>
              <tr id={"row_0"}>
                <td>T. médio atual</td>
                <td>
                  <TooltipConfig
                    content={[`${totalTmaToday} minutos`]}
                    children={totalTmaTodayTimeFormat}
                    style={false}
                  />
                </td>
              </tr>
              <tr id={"row_1"}>
                <td>T. médio histórico (4 semanas)</td>
                <td>
                  <TooltipConfig
                    content={[`${totalTmaLast4Weekdays} minutos`]}
                    children={totalTmaLast4WeekdaysTimeFormat}
                    style={false}
                  />
                </td>
              </tr>
              <tr id={"row_2"}>
                <td>T.médio histórico ({dayOfWeek})</td>
                <td>
                  <TooltipConfig
                    content={[`${totalTmaLast28Days} minutos`]}
                    children={totalTmaLast28DaysTimeFormat}
                    style={false}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};